import { createFeatureSelector } from "@ngrx/store";
import { RESOURCES_STATE_NAME } from "../../../redux/reducer/resources/resources.reducer";

export interface UIResource {
  /**
   * resource key
   */
  key?: string;
  /**
   * resource value
   */
  value?: string;
}

export interface ResourcesState {
  hu?: UIResource[];
  en?: UIResource[];

}

export const selectRecourcesState = createFeatureSelector<any, ResourcesState>(RESOURCES_STATE_NAME);
